import { render, staticRenderFns } from "./goodsImg.vue?vue&type=template&id=5be7d744&scoped=true&"
import script from "./goodsImg.vue?vue&type=script&lang=js&"
export * from "./goodsImg.vue?vue&type=script&lang=js&"
import style0 from "./goodsImg.vue?vue&type=style&index=0&id=5be7d744&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be7d744",
  null
  
)

export default component.exports